import { useCallback } from 'react';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { useTunnel } from '@wix/cli-tunnel';
import { useProjectModel } from '../../model.js';

export function useDevEditorUrl() {
  const { model } = useProjectModel();
  const createTunnel = useTunnel();

  return useCallback(
    async ({
      serverWsUrl: localServerWsUrl,
      serverPort,
      shouldUseTunnel,
    }: {
      serverWsUrl: string;
      serverPort: number;
      shouldUseTunnel: boolean;
    }) => {
      const { devEditorBaseUrl } = getTestOverrides();
      const url = new URL(
        model.metaSiteId,
        devEditorBaseUrl ?? 'https://wix.com/editor/'
      );

      const tunnelWsUrl = shouldUseTunnel
        ? ensureWsProtocol((await createTunnel(serverPort)).url)
        : undefined;

      const serverUrl = tunnelWsUrl ?? localServerWsUrl;

      url.searchParams.set('localPort', String(serverPort));
      url.searchParams.set('localEditorDestination', serverUrl);
      url.searchParams.set('localEditorWsUrl', serverUrl);
      url.searchParams.set('github2', 'true');

      return url.toString();
    },
    [model.metaSiteId, createTunnel]
  );
}

const ensureWsProtocol = (input: string) => {
  const url = new URL(input);
  url.protocol = url.protocol === 'http:' ? 'ws' : 'wss';
  return url.toString();
};
